









import Vue, { VNode } from 'vue';
import { CSSStyleOptions } from '@libs/unified-ui-framework/src/shared/common-types';

export default Vue.extend({
  functional: true,
  props: {
    width: {
      type: Number,
      default: 30,
    },
  },
  /* tslint:disable-next-line */
  render(h, context) {
    const style: CSSStyleOptions = {
      width: `${context.props.width}px`,
      border: `${(context.props.width - 1) / 2}px solid transparent`,
      borderTop: 'none',
      borderBottom: 'none',
    };
    return (
      <div class={['sw-text-tab-divider']} style={style}></div>
    ) as VNode;
  },
});
